import React from "react";
import DeviceContext from "../../../../services/indentifyDevice";
import LoginPopup from "../../../login/generic/loginPopup";
import ForgotPasswordForm, {
  VForgotPasswordFormProps,
} from "../Forms/ForgotPasswordForm";
import NuvamaLogo from "../../../../assets/new_images/nuvama-logo.svg";

export interface VForgotPasswordScreenProps extends VForgotPasswordFormProps {
  onClose?: () => void;
}
const ForgotPassword: React.FC<VForgotPasswordScreenProps> = (props) => {
  return (
    <LoginPopup
      leftHeaderContent={
        !DeviceContext().isDesktop ? (
          <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
        ) : undefined
      }
      centerHeaderContent={
        DeviceContext().isDesktop ? (
          <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
        ) : undefined
      }
      onClose={props.onClose}
      className="login_scrn"
    >
      <ForgotPasswordForm {...props} />
    </LoginPopup>
  );
};

export default ForgotPassword;
